<div *ngIf="exist; else attente"></div>
<ng-template #attente>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div class="overflow-hidden">
  <div class="head-content flex justify-between">
    <button
      (click)="goToCaisse()"
      mat-stroked-button
      style="margin-right: 10px"
      class="bg-"
    >
      <mat-icon>undo</mat-icon>
      Retour au caisse
    </button>
    <button
      *ngIf="mode == '1'"
      [disabled]="!exist || saved"
      (click)="clotuer()"
      mat-stroked-button
      class="bg-green-500 text-white"
    >
      <mat-icon>done_outline</mat-icon>
      Clôturer la journée
    </button>
  </div>
  <mat-divider></mat-divider>
  <div class="body-content">
    <div class="display-flex-2 justify-center">
      <mat-card class="w-10/12">
        <div>
          <div class="display-flex justify-around mr-12">
            <div style="width: 7%">
              <h4><b>Règlement</b></h4>
            </div>
            <div style="width: 7%">
              <h4><b> Total </b></h4>
            </div>
            <ng-container *ngIf="mode == '1'">
              <div style="width: 7%">
                <h4><b> Total Caisse</b></h4>
              </div>
              <div style="width: 7%">
                <h4><b> Différence</b></h4>
              </div>
              <div style="width: 7%">
                <h4><b> Status </b></h4>
              </div>
            </ng-container>
          </div>
          <hr class="mb-4" />
          <div
            class="display-flex items-center justify-around mr-12"
            *ngFor="let reglement of CashR_Type"
          >
            <div style="width: 7%">
              {{ reglement.DiverSys_Libelle }}
            </div>
            <div style="width: 7%">
              {{ reglement.total }}
            </div>
            <ng-container *ngIf="mode == '1'">
              <mat-form-field appearance="outline" style="width: 7%">
                <mat-label>T.{{ reglement.DiverSys_Libelle }}</mat-label>
                <input
                  type="number"
                  matInput
                  name="totalChequeCaisse"
                  [(ngModel)]="reglement.totalCaisse"
                />
              </mat-form-field>
              <div style="width: 7%">
                <samp *ngIf="reglement.totalCaisse >= 0">{{
                  (reglement.totalCaisse - reglement.total).toFixed(3)
                }}</samp>
              </div>
              <div style="width: 7%">
                <button
                  *ngIf="reglement.totalCaisse > reglement.total"
                  mat-stroked-button
                  class="bg-red-100 text-red-800 font-bold"
                >
                  Montant dépasse
                </button>
                <button
                  *ngIf="reglement.totalCaisse < reglement.total"
                  mat-stroked-button
                  class="bg-red-100 text-red-800 font-bold"
                >
                  Montant manquant
                </button>
                <button
                  *ngIf="reglement.totalCaisse == reglement.total"
                  mat-stroked-button
                  class="bg-green-100 text-green-800 font-bold"
                >
                  Montant acceptable
                </button>
              </div>
            </ng-container>
          </div>
          <hr class="mb-8" />
          <div *ngIf="mode == '1'" class="display-flex justify-around mr-12">
            <div class="text-2xl font-bold" style="width: 7%">TOTAL</div>
            <div class="text-2xl font-bold" style="width: 7%">
              {{ getTotalServeur() }}
            </div>
            <div class="text-2xl font-bold" style="width: 7%">
              {{ getTotal() }}
            </div>
            <div class="text-2xl font-bold" style="width: 7%">
              {{ (getTotal() - getTotalServeur()).toFixed(3) }}
            </div>
            <div style="width: 7%">
              <button
                *ngIf="getTotal() > getTotalServeur()"
                mat-stroked-button
                class="bg-red-100 text-red-800 font-bold"
              >
                Montant dépasse
              </button>
              <button
                *ngIf="getTotal() < getTotalServeur()"
                mat-stroked-button
                class="bg-red-100 text-red-800 font-bold"
              >
                Montant manquant
              </button>
              <button
                *ngIf="getTotal() == getTotalServeur()"
                mat-stroked-button
                class="bg-green-100 text-green-800 font-bold"
              >
                Montant acceptable
              </button>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
